














  import {
    Vue,
    Component
} from "@/shared/vuepack";
import { useDebitCardManagementStore } from "@/shared/store/debitCardManagement";
import { DebitCardManagerModalViewState } from "@/shared/types";
import { useThemeStore } from "@/shared/store/theme";

@Component({
    components: {}
  })
export default class PinsNotMatchingForm extends Vue {
    debitCardManagementStore = useDebitCardManagementStore();
    themeStore = useThemeStore();

    onGoBackClick () {
        this.debitCardManagementStore.setModalState(DebitCardManagerModalViewState.UpdatePinForm);
    }
}
